// Copyright © 2021 Move Closer
export * from './Heading.adapter';
export * from './Heading.contracts';
export * from './Heading.ui';
